import { ARM_10_1, ARM_3_1, ARM_5_1, ARM_7_1, ARM_3_6, ARM_5_6, ARM_7_6, ARM_10_6 } from "./loan_terms";

export const CAPS_1_1_5 = "1/1/5";
export const CAPS_1_1_6 = "1/1/6";
export const CAPS_1_5 = "1/5";
export const CAPS_1_6 = "1/6";
export const CAPS_2_1_5 = "2/1/5";
export const CAPS_2_1_6 = "2/1/6";
export const CAPS_2_2_5 = "2/2/5";
export const CAPS_2_2_6 = "2/2/6";
export const CAPS_2_5 = "2/5";
export const CAPS_2_6 = "2/6";
export const CAPS_5_1_5 = "5/1/5";
export const CAPS_5_1_6 = "5/1/6";
export const CAPS_5_2_5 = "5/2/5";

export const FIRST_ADJUSTMENT_CAP_PERCENTS = Object.freeze({
  [CAPS_1_1_5]: "1",
  [CAPS_1_1_6]: "1",
  [CAPS_1_5]: "1",
  [CAPS_1_6]: "1",
  [CAPS_2_1_5]: "2",
  [CAPS_2_1_6]: "2",
  [CAPS_2_2_5]: "2",
  [CAPS_2_2_6]: "2",
  [CAPS_2_5]: "2",
  [CAPS_2_6]: "2",
  [CAPS_5_1_5]: "5",
  [CAPS_5_1_6]: "5",
  [CAPS_5_2_5]: "5"
});

export const ARM_FIRST_CHANGE_MONTHS = Object.freeze({
  [ARM_10_1]: "120",
  [ARM_3_1]: "36",
  [ARM_5_1]: "60",
  [ARM_7_1]: "84",
  [ARM_3_6]: "36",
  [ARM_5_6]: "60",
  [ARM_7_6]: "84",
  [ARM_10_6]: "120"
});

export const ADJUSTMENT_CAP_PERCENTS = Object.freeze({
  [CAPS_1_1_5]: "1",
  [CAPS_1_1_6]: "1",
  [CAPS_1_5]: "1",
  [CAPS_1_6]: "1",
  [CAPS_2_1_5]: "1",
  [CAPS_2_1_6]: "1",
  [CAPS_2_2_5]: "2",
  [CAPS_2_2_6]: "2",
  [CAPS_2_5]: "2",
  [CAPS_2_6]: "2",
  [CAPS_5_1_5]: "1",
  [CAPS_5_1_6]: "1",
  [CAPS_5_2_5]: "2"
});

export const ADJUSTMENT_LIFE_CAP = Object.freeze({
  [CAPS_1_1_5]: "5",
  [CAPS_1_1_6]: "6",
  [CAPS_1_5]: "5",
  [CAPS_1_6]: "6",
  [CAPS_2_1_5]: "5",
  [CAPS_2_1_6]: "6",
  [CAPS_2_2_5]: "5",
  [CAPS_2_2_6]: "6",
  [CAPS_2_5]: "5",
  [CAPS_2_6]: "6",
  [CAPS_5_1_5]: "5",
  [CAPS_5_1_6]: "6",
  [CAPS_5_2_5]: "5"
});

export const ARM_CAPS = Object.freeze({
  [CAPS_1_1_5]: "1/1/5",
  [CAPS_1_1_6]: "1/1/6",
  [CAPS_1_5]: "1/5",
  [CAPS_1_6]: "1/6",
  [CAPS_2_1_5]: "2/1/5",
  [CAPS_2_1_6]: "2/1/6",
  [CAPS_2_2_5]: "2/2/5",
  [CAPS_2_2_6]: "2/2/6",
  [CAPS_2_5]: "2/5",
  [CAPS_2_6]: "2/6",
  [CAPS_5_1_5]: "5/1/5",
  [CAPS_5_1_6]: "5/1/6",
  [CAPS_5_2_5]: "5/2/5"
});

export const MARGIN_2_00 = "2";
export const MARGIN_2_125 = "2.125";
export const MARGIN_2_25 = "2.25";
export const MARGIN_2_375 = "2.375";
export const MARGIN_2_50 = "2.5";
export const MARGIN_2_625 = "2.625";
export const MARGIN_2_75 = "2.75";
export const MARGIN_2_875 = "2.875";
export const MARGIN_3_00 = "3.0";
export const MARGIN_3_125 = "3.125";
export const MARGIN_3_25 = "3.25";
export const MARGIN_3_375 = "3.375";
export const MARGIN_3_50 = "3.5";

export const ARM_MARGINS = Object.freeze({
  [MARGIN_2_00]: "2.00%",
  [MARGIN_2_125]: "2.125%",
  [MARGIN_2_25]: "2.25%",
  [MARGIN_2_375]: "2.375%",
  [MARGIN_2_50]: "2.50%",
  [MARGIN_2_625]: "2.625%",
  [MARGIN_2_75]: "2.75%",
  [MARGIN_2_875]: "2.875%",
  [MARGIN_3_00]: "3.00%",
  [MARGIN_3_125]: "3.125%",
  [MARGIN_3_25]: "3.25%",
  [MARGIN_3_375]: "3.375%",
  [MARGIN_3_50]: "3.50%"
});

export const LIBOR_1_MO = "1";
export const LIBOR_1_YR = "2";
export const T_BILL_1_YR = "3";
export const T_BILL_10_YR = "4";
export const LIBOR_3_MO = "5";
export const T_BILL_3_YR = "6";
export const T_BILL_5_YR = "7";
export const CD_6_MO = "8";
export const LIBOR_6_MO = "9";
export const T_BILL_6_MO = "10";
export const CODI = "11";
export const COFI = "12";
export const DAILY_CD_RATE = "13";
export const FEDERAL_COST_OF_FUNDS = "14";
export const FHLMC_60_DAY_REQ_NET_YIELD = "15";
export const FNMA_60_DAY_REQ_NET_YIELD = "16";
export const MTA = "17";
export const NATL_AVE_CONTRACT_RATE_FHLBB = "18";
export const NATL_MO_MEDIAN_COST_OF_FUNDS = "19";
export const PRIME_RATE = "20";
export const ALT_INDEX = "21";
export const SOFR = "22";

export const ARM_INDEX_TYPES = Object.freeze({
  [LIBOR_1_MO]: "1 Mo LIBOR",
  [LIBOR_1_YR]: "1 Yr. LIBOR",
  [T_BILL_1_YR]: "1 Yr. T-Bill",
  [T_BILL_10_YR]: "10 Yr. T-Bill",
  [LIBOR_3_MO]: "3 Mo LIBOR",
  [T_BILL_3_YR]: "3 Yr. T-Bill",
  [T_BILL_5_YR]: "5 Yr. T-Bill",
  [CD_6_MO]: "6 Mo CD",
  [LIBOR_6_MO]: "6 Mo LIBOR",
  [T_BILL_6_MO]: "6 Mo T-Bill",
  [ALT_INDEX]: "Alt Index",
  [CODI]: "CODI",
  [COFI]: "COFI",
  [DAILY_CD_RATE]: "Daily CD Rate",
  [FEDERAL_COST_OF_FUNDS]: "Federal Cost of Funds",
  [FHLMC_60_DAY_REQ_NET_YIELD]: "FHLMC 60 Day Req Net Yield",
  [FNMA_60_DAY_REQ_NET_YIELD]: "FNMA 60 Day Req Net Yield",
  [MTA]: "MTA",
  [NATL_AVE_CONTRACT_RATE_FHLBB]: "Natl Ave Contract Rate (FHLBB)",
  [NATL_MO_MEDIAN_COST_OF_FUNDS]: "Natl Mo Median Cost of Funds",
  [PRIME_RATE]: "Prime Rate",
  [SOFR]: "SOFR"
});

export const ADJUSTMENT_PERIOD = "12";

export const ARM_ADJUSTMENT_PERIOD = Object.freeze({
  [ARM_10_1]: "12",
  [ARM_7_1]: "12",
  [ARM_5_1]: "12",
  [ARM_3_1]: "12",
  [ARM_3_6]: "6",
  [ARM_5_6]: "6",
  [ARM_7_6]: "6",
  [ARM_10_6]: "6"
});
